module.exports = __webpack_public_path__ + "static/img/about.7248859.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/about.jpg
// module id = DKDY
// module chunks = 1